import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { User, Users, Award } from "lucide-react";

const valueChips = [
  { icon: User, text: "Ein Ansprechpartner" },
  { icon: Users, text: "Koordination aller Gewerke" },
  { icon: Award, text: "Qualität bis ins Detail" }
];

const AboutSection = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: "-100px" });

  return (
    <section 
      ref={sectionRef}
      id="ueber-uns" 
      className="py-24 md:py-32 bg-komel-neutral-100 overflow-hidden"
      data-testid="about-section"
    >
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="max-w-4xl">
          {/* Content */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8 }}
          >
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-komel-primary mb-4" data-testid="about-title">
              Regional. Verlässlich. Direkt.
            </h2>
            <div className="w-20 h-1 bg-komel-accent mb-8" />

            <div className="space-y-6 text-komel-secondary leading-relaxed mb-10 text-lg">
              <p>
                Als regional verankertes Unternehmen in St. Gallen kennen wir die Gegebenheiten vor Ort. 
                Kurze Wege, klare Ansprechpartner und eine persönliche Betreuung sind für uns selbstverständlich. 
                Bei uns haben Sie immer einen direkten Draht zur Baustelle.
              </p>
              <p>
                Wir koordinieren alle Gewerke, achten auf höchste Qualität und halten Termine ein. 
                Transparente Kommunikation und faire Abwicklung sind das Fundament unserer Arbeit – 
                damit Ihr Bauprojekt zum Erfolg wird.
              </p>
            </div>

            {/* Value Chips */}
            <div className="flex flex-wrap gap-3" data-testid="value-chips">
              {valueChips.map((chip, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={isInView ? { opacity: 1, scale: 1 } : {}}
                  transition={{ duration: 0.4, delay: 0.4 + index * 0.1 }}
                  className="inline-flex items-center gap-2 px-5 py-3 bg-white shadow-md"
                  data-testid={`value-chip-${index}`}
                >
                  <chip.icon className="w-5 h-5 text-komel-accent" />
                  <span className="font-medium text-komel-primary">{chip.text}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
